import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { IonicModule } from "ionic-angular";
import { EvaChatComponent } from "./eva-chat";

@NgModule({
  declarations: [EvaChatComponent],
  imports: [CommonModule, FormsModule, IonicModule],
  exports: [EvaChatComponent],
})
export class EvaChatModule {}



// WEBPACK FOOTER //
// ./src/components/eva-chat/eva-chat.module.ts